import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANGUAGE_CODES, DEFAULT_LANGUAGE } from './languages';
import { handleMissingKey } from './missingKeys';

// English locale files (source of truth)
import commonEn from './locales/en/common.json';
import landingEn from './locales/en/landing.json';
import seoEn from './locales/en/seo.json';
import dashboardEn from './locales/en/dashboard.json';
import shootsEn from './locales/en/shoots.json';
import pricingEn from './locales/en/pricing.json';
import authEn from './locales/en/auth.json';
import settingsEn from './locales/en/settings.json';
import pricingPageEn from './locales/en/pricing_page.json';
import onboardingEn from './locales/en/onboarding.json';
import demoEn from './locales/en/demo.json';
import nicheEn from './locales/en/niche.json';
import legalEn from './locales/en/legal.json';
import clientBriefEn from './locales/en/client_brief.json';
import shootDetailEn from './locales/en/shoot_detail.json';

// Translated locales
import commonFr from './locales/fr/common.json';
import landingFr from './locales/fr/landing.json';
import seoFr from './locales/fr/seo.json';
import dashboardFr from './locales/fr/dashboard.json';
import shootsFr from './locales/fr/shoots.json';
import pricingFr from './locales/fr/pricing.json';
import authFr from './locales/fr/auth.json';
import settingsFr from './locales/fr/settings.json';
import pricingPageFr from './locales/fr/pricing_page.json';
import onboardingFr from './locales/fr/onboarding.json';
import demoFr from './locales/fr/demo.json';
import nicheFr from './locales/fr/niche.json';
import legalFr from './locales/fr/legal.json';
import clientBriefFr from './locales/fr/client_brief.json';
import shootDetailFr from './locales/fr/shoot_detail.json';

import commonDe from './locales/de/common.json';
import landingDe from './locales/de/landing.json';
import seoDe from './locales/de/seo.json';
import dashboardDe from './locales/de/dashboard.json';
import shootsDe from './locales/de/shoots.json';
import pricingDe from './locales/de/pricing.json';
import authDe from './locales/de/auth.json';
import settingsDe from './locales/de/settings.json';
import pricingPageDe from './locales/de/pricing_page.json';
import onboardingDe from './locales/de/onboarding.json';
import demoDe from './locales/de/demo.json';
import nicheDe from './locales/de/niche.json';
import legalDe from './locales/de/legal.json';
import clientBriefDe from './locales/de/client_brief.json';
import shootDetailDe from './locales/de/shoot_detail.json';

import commonZh from './locales/zh/common.json';
import landingZh from './locales/zh/landing.json';
import seoZh from './locales/zh/seo.json';
import dashboardZh from './locales/zh/dashboard.json';
import shootsZh from './locales/zh/shoots.json';
import pricingZh from './locales/zh/pricing.json';
import authZh from './locales/zh/auth.json';
import settingsZh from './locales/zh/settings.json';
import pricingPageZh from './locales/zh/pricing_page.json';
import onboardingZh from './locales/zh/onboarding.json';
import demoZh from './locales/zh/demo.json';
import nicheZh from './locales/zh/niche.json';
import legalZh from './locales/zh/legal.json';
import clientBriefZh from './locales/zh/client_brief.json';
import shootDetailZh from './locales/zh/shoot_detail.json';

import commonRu from './locales/ru/common.json';
import landingRu from './locales/ru/landing.json';
import seoRu from './locales/ru/seo.json';
import dashboardRu from './locales/ru/dashboard.json';
import shootsRu from './locales/ru/shoots.json';
import pricingRu from './locales/ru/pricing.json';
import authRu from './locales/ru/auth.json';
import settingsRu from './locales/ru/settings.json';
import pricingPageRu from './locales/ru/pricing_page.json';
import onboardingRu from './locales/ru/onboarding.json';
import demoRu from './locales/ru/demo.json';
import nicheRu from './locales/ru/niche.json';
import legalRu from './locales/ru/legal.json';
import clientBriefRu from './locales/ru/client_brief.json';
import shootDetailRu from './locales/ru/shoot_detail.json';

import commonCs from './locales/cs/common.json';
import landingCs from './locales/cs/landing.json';
import seoCs from './locales/cs/seo.json';
import dashboardCs from './locales/cs/dashboard.json';
import shootsCs from './locales/cs/shoots.json';
import pricingCs from './locales/cs/pricing.json';
import authCs from './locales/cs/auth.json';
import settingsCs from './locales/cs/settings.json';
import pricingPageCs from './locales/cs/pricing_page.json';
import onboardingCs from './locales/cs/onboarding.json';
import demoCs from './locales/cs/demo.json';
import nicheCs from './locales/cs/niche.json';
import legalCs from './locales/cs/legal.json';
import clientBriefCs from './locales/cs/client_brief.json';
import shootDetailCs from './locales/cs/shoot_detail.json';

import commonIt from './locales/it/common.json';
import landingIt from './locales/it/landing.json';
import seoIt from './locales/it/seo.json';
import dashboardIt from './locales/it/dashboard.json';
import shootsIt from './locales/it/shoots.json';
import pricingIt from './locales/it/pricing.json';
import authIt from './locales/it/auth.json';
import settingsIt from './locales/it/settings.json';
import pricingPageIt from './locales/it/pricing_page.json';
import onboardingIt from './locales/it/onboarding.json';
import demoIt from './locales/it/demo.json';
import nicheIt from './locales/it/niche.json';
import legalIt from './locales/it/legal.json';
import clientBriefIt from './locales/it/client_brief.json';
import shootDetailIt from './locales/it/shoot_detail.json';

import commonEs from './locales/es/common.json';
import landingEs from './locales/es/landing.json';
import seoEs from './locales/es/seo.json';
import dashboardEs from './locales/es/dashboard.json';
import shootsEs from './locales/es/shoots.json';
import pricingEs from './locales/es/pricing.json';
import authEs from './locales/es/auth.json';
import settingsEs from './locales/es/settings.json';
import pricingPageEs from './locales/es/pricing_page.json';
import onboardingEs from './locales/es/onboarding.json';
import demoEs from './locales/es/demo.json';
import nicheEs from './locales/es/niche.json';
import legalEs from './locales/es/legal.json';
import clientBriefEs from './locales/es/client_brief.json';
import shootDetailEs from './locales/es/shoot_detail.json';

const NS = ['common', 'landing', 'seo', 'dashboard', 'shoots', 'pricing', 'auth', 'settings', 'pricing_page', 'onboarding', 'demo', 'niche', 'legal', 'client_brief', 'shoot_detail'] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: commonEn, landing: landingEn, seo: seoEn, dashboard: dashboardEn, shoots: shootsEn, pricing: pricingEn, auth: authEn, settings: settingsEn, pricing_page: pricingPageEn, onboarding: onboardingEn, demo: demoEn, niche: nicheEn, legal: legalEn, client_brief: clientBriefEn, shoot_detail: shootDetailEn },
      fr: { common: commonFr, landing: landingFr, seo: seoFr, dashboard: dashboardFr, shoots: shootsFr, pricing: pricingFr, auth: authFr, settings: settingsFr, pricing_page: pricingPageFr, onboarding: onboardingFr, demo: demoFr, niche: nicheFr, legal: legalFr, client_brief: clientBriefFr, shoot_detail: shootDetailFr },
      de: { common: commonDe, landing: landingDe, seo: seoDe, dashboard: dashboardDe, shoots: shootsDe, pricing: pricingDe, auth: authDe, settings: settingsDe, pricing_page: pricingPageDe, onboarding: onboardingDe, demo: demoDe, niche: nicheDe, legal: legalDe, client_brief: clientBriefDe, shoot_detail: shootDetailDe },
      zh: { common: commonZh, landing: landingZh, seo: seoZh, dashboard: dashboardZh, shoots: shootsZh, pricing: pricingZh, auth: authZh, settings: settingsZh, pricing_page: pricingPageZh, onboarding: onboardingZh, demo: demoZh, niche: nicheZh, legal: legalZh, client_brief: clientBriefZh, shoot_detail: shootDetailZh },
      ru: { common: commonRu, landing: landingRu, seo: seoRu, dashboard: dashboardRu, shoots: shootsRu, pricing: pricingRu, auth: authRu, settings: settingsRu, pricing_page: pricingPageRu, onboarding: onboardingRu, demo: demoRu, niche: nicheRu, legal: legalRu, client_brief: clientBriefRu, shoot_detail: shootDetailRu },
      cs: { common: commonCs, landing: landingCs, seo: seoCs, dashboard: dashboardCs, shoots: shootsCs, pricing: pricingCs, auth: authCs, settings: settingsCs, pricing_page: pricingPageCs, onboarding: onboardingCs, demo: demoCs, niche: nicheCs, legal: legalCs, client_brief: clientBriefCs, shoot_detail: shootDetailCs },
      it: { common: commonIt, landing: landingIt, seo: seoIt, dashboard: dashboardIt, shoots: shootsIt, pricing: pricingIt, auth: authIt, settings: settingsIt, pricing_page: pricingPageIt, onboarding: onboardingIt, demo: demoIt, niche: nicheIt, legal: legalIt, client_brief: clientBriefIt, shoot_detail: shootDetailIt },
      es: { common: commonEs, landing: landingEs, seo: seoEs, dashboard: dashboardEs, shoots: shootsEs, pricing: pricingEs, auth: authEs, settings: settingsEs, pricing_page: pricingPageEs, onboarding: onboardingEs, demo: demoEs, niche: nicheEs, legal: legalEs, client_brief: clientBriefEs, shoot_detail: shootDetailEs },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGE_CODES,
    defaultNS: 'common',
    ns: [...NS],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    saveMissing: true,
    missingKeyHandler: handleMissingKey,
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.language || DEFAULT_LANGUAGE;

export default i18n;
